import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { STREAM__WITH_OFFSET__INITIALIZE, STREAM__WITH_OFFSET__INSERT_ITEMS, STREAM__WITH_OFFSET__FETCH, STREAM__WITH_OFFSET__FETCH_SUCCESS, STREAM__WITH_OFFSET__FETCH_SUCCESS_DEDUPE, fetchPrevious, fetchPreviousSuccess, emptyStream, resetStream, fetchAllSuccess } from './actions';
import { handleInitAction, handleFetchAction, handleFetchSuccessAction, commonActionHandlers, handleFetchPreviousSuccessAction, handleEmptyStream, handleResetStream, handleFetchAllSuccessAction } from '../base/actionHandlers';
import { handleInsertItemsAction, handleDeleteItemsAction, dedupeFetchResults } from './actionHandlers';
import { STREAM__DELETE_ITEMS } from '../base/actions';
import { StreamType } from '../types';
import { defaultStreamState } from '../constants';
const actionHandlers = _object_spread_props(_object_spread({
    [STREAM__WITH_OFFSET__INITIALIZE]: (streamState, action)=>{
        return _object_spread_props(_object_spread({}, handleInitAction(streamState, action)), {
            nextOffset: action.nextOffset,
            prevOffset: action.prevOffset
        });
    },
    [STREAM__WITH_OFFSET__FETCH]: (streamState)=>handleFetchAction(streamState),
    [STREAM__WITH_OFFSET__FETCH_SUCCESS]: (streamState, action)=>_object_spread_props(_object_spread({}, handleFetchSuccessAction(streamState, action)), {
            prevOffset: action.prevOffset,
            nextOffset: action.nextOffset
        }),
    [STREAM__WITH_OFFSET__FETCH_SUCCESS_DEDUPE]: (streamState, action)=>dedupeFetchResults(streamState, action),
    [STREAM__WITH_OFFSET__INSERT_ITEMS]: (streamState, action)=>handleInsertItemsAction(streamState, action),
    [fetchPrevious.toString()]: handleFetchAction,
    [fetchPreviousSuccess.toString()]: (streamState, action)=>_object_spread_props(_object_spread({}, handleFetchPreviousSuccessAction(streamState, action)), {
            prevOffset: action.payload.prevOffset
        }),
    [fetchAllSuccess.toString()]: (streamState, action)=>_object_spread_props(_object_spread({}, handleFetchAllSuccessAction(streamState, action)), {
            prevOffset: undefined,
            nextOffset: undefined
        }),
    [emptyStream.toString()]: (streamState, action)=>_object_spread_props(_object_spread({}, handleEmptyStream(streamState, action)), {
            nextOffset: undefined,
            prevOffset: undefined
        }),
    [resetStream.toString()]: (streamState, action)=>_object_spread_props(_object_spread({}, handleResetStream(streamState, action)), {
            nextOffset: 0,
            prevOffset: undefined
        })
}, commonActionHandlers), {
    // overrides
    [STREAM__DELETE_ITEMS]: (streamState, action)=>handleDeleteItemsAction(streamState, action)
});
const reducer = (streamState = _object_spread_props(_object_spread({}, defaultStreamState), {
    streamType: StreamType.WITH_OFFSET
}), action)=>{
    const handler = actionHandlers[action.type];
    return handler && handler(streamState, action) || streamState;
};
export default reducer;

//# sourceMappingURL=reducer.js.map